import React from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
// import { ReactComponent as HeaderLogoIcon } from '../../assets/images/headerlogo.svg'
import { ReactComponent as HeaderLogoIcon } from '../../assets/images/footerlogo.svg'
import { ReactComponent as BackIcon } from '../../assets/images/left-arrow.svg'
import {forgotpassword, home, signin} from '../../Routes/routingConsts'
import PasswordInput from '../../components/PasswordInput'
import { useMutation } from 'react-query'
import requestApi from '../../utils/request'
import Swal from 'sweetalert2'

const resetPasswordValidationSchema = yup.object().shape({
    newPassword: yup
        .string()
        .required('Please enter new password')
        .when('currentPassword', (currentPassword) => {
            if (currentPassword)
                return yup
                    .string()
                    .notOneOf(
                        [yup.ref(`currentPassword`), null],
                        'Current password and New password should not be same'
                    )
                    .required('Please enter new password')
        }),
    confirmPassword: yup
        .string()
        .required('Please enter confirm password')
        .oneOf(
            [yup.ref(`newPassword`), null],
            'New password and confirm password does not match'
        )
})

const ResetPassword = () => {
    const navigate = useNavigate()
    const { token } = useParams()

    async function resetpassword({ newPassword, confirmPassword }) {
        return await requestApi.post(`/reset-password/${token}`, {
            newPassword: newPassword,
            confirmPassword: confirmPassword
        })
    }
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({ resolver: yupResolver(resetPasswordValidationSchema) })

    const mutation = useMutation(resetpassword, {
        onSuccess: ({data}) => {

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: data?.meta?.message
            }).then(()=>{
                navigate(signin)
                reset()
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })

    const handleOnSubmit = ({ newPassword, confirmPassword }) => {
        mutation.mutate({
            newPassword,
            confirmPassword
        })
    }
    return (
        <>
            <div className="reset-password auth-page">
                <div className="container">
                    <div className="reset-pwd auth-center  auth-wrapper">
                        <div className="reset-page-header">
                            <HeaderLogoIcon />
                        </div>
                        <Row className="row">
                            <Col className="comman-form-col form-wrapper reset-pwd-form m-0">
                                {/* <div className="previous-page-icon">
                                    <Link to={forgotpassword}>
                                        <span className="back-btn">
                                            <BackIcon className="back-icon" />
                                            Back
                                        </span>
                                    </Link>
                                </div> */}
                                <div className="reset-form center-form">
                                    <div className="form-title">
                                        <h2>Reset Password</h2>
                                        <p>
                                            Enter the one type of password that
                                            you have received in your mail here.
                                        </p>
                                    </div>
                                    <Form
                                        onSubmit={handleSubmit(handleOnSubmit)}
                                    >
                                        <PasswordInput
                                            label="New Password"
                                            name="newPassword"
                                            error={errors.newPassword?.message}
                                            register={register}
                                        />
                                        <PasswordInput
                                            label="Confirm Password"
                                            name="confirmPassword"
                                            error={
                                                errors.confirmPassword?.message
                                            }
                                            register={register}
                                        />
                                        <Button
                                            className="common-btn comman-auth-btn reset-pwd-btn"
                                            type="submit"
                                        >
                                            Submit
                                        </Button>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ResetPassword
